const dateLabel = value => value?.slice(0, 10).split("-").reverse().join("/");

export default function AdminPaymentFunnel({ data, period }) {
  if (!data) return null;
  const metrics = [
    ["Total de personas registradas", data.total_users],
    ["Personas que abrieron el pago", data.checkout_opened],
    ["Personas que pagaron en el período", data.paying_users ?? data.payment_success],
    ["Conversión del período", data.conversion_rate == null ? null : `${data.conversion_rate}%`],
  ];
  return <section aria-labelledby="payment-funnel-title" className="pt-4 border-t mt-4">
    <div className="bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-xl border border-indigo-100 dark:border-indigo-800/30">
      <h3 id="payment-funnel-title" className="text-sm font-medium text-indigo-800 dark:text-indigo-300">Pagos en el período seleccionado</h3>
      {period?.start && period?.end && <p className="mt-1 text-xs text-indigo-700 dark:text-indigo-300">Del {dateLabel(period.start)} al {dateLabel(period.end)}</p>}
      <dl className="grid grid-cols-2 xl:grid-cols-4 gap-4 mt-4">
        {metrics.map(([label, value]) => <div key={label} className="text-center">
          <dt className="text-xs text-indigo-600 dark:text-indigo-400 uppercase mb-1">{label}</dt>
          <dd className="text-2xl font-bold text-indigo-900 dark:text-indigo-100">{value ?? "—"}</dd>
        </div>)}
      </dl>
      <p className="text-xs text-indigo-700 dark:text-indigo-300 mt-4">Conversión = personas que pagaron en el período ÷ total de personas registradas × 100. Cada persona cuenta una sola vez; los administradores quedan excluidos.</p>
      <p className="text-xs text-indigo-700 dark:text-indigo-300 mt-2">Este conteo puede diferir de «Con plan vigente hoy»: un plan puede seguir activo por un pago anterior al período o por una activación manual. Una persona que pagó en el período también puede tener un plan ya vencido.</p>
    </div>
  </section>;
}
